export default __webpack_public_path__ + "static/media/qrcode.ff908d45.png";